export const LABEL_FETCH_REQUEST = 'LABEL_FETCH_REQUEST';
export const LABEL_FETCH = 'LABEL_FETCH';
export const LABEL_CREATE_REQUEST = 'LABEL_CREATE_REQUEST';
export const LABEL_CREATE = 'LABEL_CREATE';
export const LABEL_UPDATE_REQUEST = 'LABEL_UPDATE_REQUEST';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DELETE_REQUEST = 'LABEL_DELETE_REQUEST';
export const LABEL_DELETE = 'LABEL_DELETE';
export const LABEL_CLEAR = 'LABEL_CLEAR';
